import styled from 'styled-components';

interface ContainerProps {
  gridColumn?: number;
  border?: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  gap: 5px;
  border-radius: 6px;
  grid-column: ${({gridColumn}) => `span ${gridColumn ?? 12}`};
`;

export const ContainerLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: white;
`;

export const Label = styled.label`
  font-weight: 600;
  color: ${(props) => props.theme.colors.text};
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  color: ${(props) => props.theme.colors.text};
`;
